import React from 'react';
import { Input } from 'web-ui-components/lib/atoms/forms';
import { Field as FormField, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { Field } from 'react-final-form';
import { Content } from '../infrastructure/content';
import { isLinkCode } from '../utils/validation';

const LinkCode = () => (
  <Content>
    {({ linkCodeHeading = '', enterLinkCodeError = '' }) => (
      <Field name="link_code" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <FormField>
            <FieldHeader
              name="link_code"
              hasError={touched && !!error}
              title={linkCodeHeading}
              validationMessage={enterLinkCodeError}
            />
            <FieldBody hasError={touched && !!error}>
              <Field name="link_code" component="input" validate={isLinkCode}>
                {({ input }) => <Input name="link_code" maxLength="6" type="text" {...input} />}
              </Field>
            </FieldBody>
          </FormField>
        )}
      </Field>
    )}
  </Content>
);

export default LinkCode;
